import { render, staticRenderFns } from "./EditCandidateProps.vue?vue&type=template&id=4dc54dee"
import script from "./EditCandidateProps.vue?vue&type=script&lang=js"
export * from "./EditCandidateProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports